import { render } from "./Shippingreturns.vue?vue&type=template&id=066420d2&scoped=true"
import script from "./Shippingreturns.vue?vue&type=script&lang=js"
export * from "./Shippingreturns.vue?vue&type=script&lang=js"

import "./Shippingreturns.vue?vue&type=style&index=0&id=066420d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-066420d2"]])

export default __exports__